import React, { FC, memo, useMemo, MouseEvent, KeyboardEvent } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';
import { Tabs } from 'antd';
import { LeftOutlined, MenuOutlined, RightOutlined } from '@ant-design/icons';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { AllState } from '@/state';
import { useHistory } from 'react-router-dom';
import { actions as mainActions } from '@/modules/main';

interface Props {}

const Index: FC<Props> = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { activeTabKey, tabItems } = useSelector(
    (state: AllState) => ({ activeTabKey: state.main.activeTabKey, tabItems: state.main.tabItems }),
    shallowEqual,
  );

  const length = tabItems.length;

  const tabIndex = useMemo(() => tabItems.findIndex((_) => _.key === activeTabKey), [activeTabKey, tabItems]);

  const handleChange = (key: string) => {
    history.push(key);
    dispatch(mainActions.setState({ activeTabKey: key }));
  };

  const goPreTab = () => {
    if (tabIndex > 0) {
      const preKey = tabItems?.[tabIndex - 1]?.key;
      if (preKey) {
        history.push(preKey.toString());
        dispatch(mainActions.setState({ activeTabKey: preKey }));
      }
    }
  };

  const goNextTab = () => {
    if (tabIndex < length) {
      const nextKey = tabItems?.[tabIndex + 1]?.key;
      if (nextKey) {
        history.push(nextKey.toString());
        dispatch(mainActions.setState({ activeTabKey: nextKey }));
      }
    }
  };

  const handleEdit = (event: MouseEvent | KeyboardEvent | string, action: 'add' | 'remove') => {
    if (typeof event === 'string' && action === 'remove') {
      dispatch(mainActions.deleteTabByUrl(event));
    }
  };

  return tabItems.length ? (
    <div className={classNames(styles.container, 'flex justify-center items-center h-8')}>
      <div
        className='w-4 bg-white h-full flex items-center justify-center border-b border-t border-[#DCDFE6] cursor-pointer'
        onClick={goPreTab}
      >
        <LeftOutlined className='size-[10px] text-[#616266]' />
      </div>
      <Tabs
        rootClassName={classNames(styles.tabs, 'flex-1 h-full')}
        hideAdd
        type='editable-card'
        activeKey={activeTabKey?.toString()}
        onChange={handleChange}
        onEdit={handleEdit}
        items={tabItems.map((_) => ({
          label: `${_.label}${_.addonAfter}`,
          key: _.key.toString(),
          closable: length > 1 && _.key === activeTabKey,
        }))}
      />
      <div
        className='w-4 bg-white h-full flex items-center justify-center border-l border-b border-t border-[#DCDFE6] cursor-pointer'
        onClick={goNextTab}
      >
        <RightOutlined className='size-[10px] text-[#616266]' />
      </div>
      <div className='w-[34px] bg-white h-full flex items-center justify-center border-l border-b border-t border-[#DCDFE6] cursor-pointer'>
        <MenuOutlined className='size-3 text-[#616266]' />
      </div>
    </div>
  ) : null;
};

export default memo(Index);
